<template>
  <v-card class="client-table-card" :class="{ selected }" variant="flat">
    <v-img class="client-table-card__thumb" :src="item.image_url" :alt="item.title" aspect-ratio="0.72" cover />
    <div class="client-table-card__body">
      <div class="client-table-card__title">{{ item.title || 'Без названия' }}</div>
      <div class="tag-row client-table-card__tags">
        <v-chip v-for="tag in item.tags || []" :key="tag" size="x-small" variant="tonal">{{ tag }}</v-chip>
        <span v-if="!item.tags?.length" class="muted small-text">Нет тэгов</span>
      </div>
      <div class="client-table-card__actions">
        <v-btn size="small" :color="selected ? 'secondary' : 'primary'" :variant="selected ? 'tonal' : 'flat'" :prepend-icon="selected ? 'mdi-close-circle-outline' : 'mdi-check-circle-outline'" @click="$emit('toggle', item)">
          {{ selected ? 'Снять' : 'Выбрать' }}
        </v-btn>
        <v-btn size="small" color="primary" variant="tonal" prepend-icon="mdi-magnify-plus-outline" @click="$emit('preview', item)">
          Увеличить
        </v-btn>
      </div>
    </div>
  </v-card>
</template>

<script setup>
defineProps({ item: { type: Object, required: true }, selected: Boolean });
defineEmits(['toggle', 'preview']);
</script>
